// Domain: Roles and Permissions Constants
// Following DDD principles for role-based access control

// 1. Agregar SUPER_ADMIN a ROLES
export const ROLES  = {
    SUPER_ADMIN: "SUPER_ADMIN",
    ADMIN: "ADMIN",
    AGENT: "AGENT",
    LEGAL: "LEGAL",
    REVIEWER: "REVIEWER",
    INVESTOR: "INVESTOR",
    ANALYST: "ANALYST"
};

// 2. Agregar BUSINESS a PERMISSIONS
export const PERMISSIONS  = {
    // Opportunity permissions
    VIEW_OPPORTUNITY: "VIEW_OPPORTUNITY",
    EDIT_OPPORTUNITY: "EDIT_OPPORTUNITY",
    CREATE_OPPORTUNITY: "CREATE_OPPORTUNITY",
    DELETE_OPPORTUNITY: "DELETE_OPPORTUNITY",
    APPROVE_OPPORTUNITY: "APPROVE_OPPORTUNITY",
    // Document permissions
    VIEW_DOCUMENTS: "VIEW_DOCUMENTS",
    UPLOAD_DOCUMENTS: "UPLOAD_DOCUMENTS",
    VALIDATE_DOCUMENTS: "VALIDATE_DOCUMENTS",
    // Task permissions
    VIEW_TASKS: "VIEW_TASKS",
    CREATE_TASKS: "CREATE_TASKS",
    UPDATE_TASKS: "UPDATE_TASKS",
    ASSIGN_TASKS: "ASSIGN_TASKS",
    // KYC permissions
    VIEW_KYC: "VIEW_KYC",
    APPROVE_KYC: "APPROVE_KYC",
    REJECT_KYC: "REJECT_KYC",
    // Portfolio permissions
    VIEW_PORTFOLIO: "VIEW_PORTFOLIO",
    VIEW_PERSONAL_PORTFOLIO: "VIEW_PERSONAL_PORTFOLIO",
    // Admin permissions
    MANAGE_USERS: "MANAGE_USERS",
    MANAGE_AGENTS: "MANAGE_AGENTS",
    VIEW_REPORTS: "VIEW_REPORTS",
    MANAGE_SYSTEM: "MANAGE_SYSTEM",
    // Business permission
    BUSINESS: "BUSINESS"
};

// 3. Agregar mapping de SUPER_ADMIN en ROLE_PERMISSIONS con todos los permisos
export const ROLE_PERMISSIONS  = {
    [ROLES.SUPER_ADMIN]: [
        ...Object.values(PERMISSIONS)
    ],
    [ROLES.ADMIN]: [
        PERMISSIONS.VIEW_OPPORTUNITY,
        PERMISSIONS.EDIT_OPPORTUNITY,
        PERMISSIONS.CREATE_OPPORTUNITY,
        PERMISSIONS.DELETE_OPPORTUNITY,
        PERMISSIONS.APPROVE_OPPORTUNITY,
        PERMISSIONS.VIEW_DOCUMENTS,
        PERMISSIONS.UPLOAD_DOCUMENTS,
        PERMISSIONS.VALIDATE_DOCUMENTS,
        PERMISSIONS.VIEW_TASKS,
        PERMISSIONS.CREATE_TASKS,
        PERMISSIONS.UPDATE_TASKS,
        PERMISSIONS.ASSIGN_TASKS,
        PERMISSIONS.VIEW_KYC,
        PERMISSIONS.APPROVE_KYC,
        PERMISSIONS.REJECT_KYC,
        PERMISSIONS.VIEW_PORTFOLIO,
        PERMISSIONS.VIEW_PERSONAL_PORTFOLIO,
        PERMISSIONS.MANAGE_USERS,
        PERMISSIONS.MANAGE_AGENTS,
        PERMISSIONS.VIEW_REPORTS,
        PERMISSIONS.MANAGE_SYSTEM,
    ],
    [ROLES.AGENT]: [
        PERMISSIONS.VIEW_OPPORTUNITY,
        PERMISSIONS.EDIT_OPPORTUNITY,
        PERMISSIONS.CREATE_OPPORTUNITY,
        PERMISSIONS.VIEW_DOCUMENTS,
        PERMISSIONS.UPLOAD_DOCUMENTS,
        PERMISSIONS.VIEW_TASKS,
        PERMISSIONS.UPDATE_TASKS,
        PERMISSIONS.VIEW_PERSONAL_PORTFOLIO,
    ],
    [ROLES.LEGAL]: [
        PERMISSIONS.VIEW_OPPORTUNITY,
        PERMISSIONS.VIEW_DOCUMENTS,
        PERMISSIONS.VALIDATE_DOCUMENTS,
        PERMISSIONS.VIEW_TASKS,
        PERMISSIONS.UPDATE_TASKS,
        PERMISSIONS.VIEW_KYC,
        PERMISSIONS.APPROVE_KYC,
        PERMISSIONS.REJECT_KYC,
    ],
    [ROLES.REVIEWER]: [
        PERMISSIONS.VIEW_OPPORTUNITY,
        PERMISSIONS.APPROVE_OPPORTUNITY,
        PERMISSIONS.VIEW_DOCUMENTS,
        PERMISSIONS.VALIDATE_DOCUMENTS,
        PERMISSIONS.VIEW_TASKS,
        PERMISSIONS.ASSIGN_TASKS,
        PERMISSIONS.VIEW_KYC,
        PERMISSIONS.APPROVE_KYC,
        PERMISSIONS.REJECT_KYC,
    ],
    [ROLES.ANALYST]: [
        PERMISSIONS.VIEW_OPPORTUNITY,
        PERMISSIONS.EDIT_OPPORTUNITY,
        PERMISSIONS.VIEW_DOCUMENTS,
        PERMISSIONS.VIEW_TASKS,
        PERMISSIONS.UPDATE_TASKS,
        PERMISSIONS.VIEW_REPORTS,
    ],
    [ROLES.INVESTOR]: [
        PERMISSIONS.VIEW_OPPORTUNITY,
        PERMISSIONS.VIEW_PERSONAL_PORTFOLIO,
    ],
};

// Helper function to check if a role has a specific permission
export const hasPermission = (role, permission) => {
    return ROLE_PERMISSIONS[role]?.includes(permission) || false;
};

// Helper function to get all permissions for a role
export const getRolePermissions = (role) => {
    return ROLE_PERMISSIONS[role] || [];
}; 